import { render } from "./OperatePurchaseDefectiveItemCreate.vue?vue&type=template&id=0bc5aaba"
import script from "./OperatePurchaseDefectiveItemCreate.vue?vue&type=script&lang=js"
export * from "./OperatePurchaseDefectiveItemCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__